export default __webpack_public_path__ + "static/time-basis-ed4ef9e032bd76db89da0bf989168245.png";